import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGcUGmRzY_jsD3niQwheeA4eX_uRvGwi8",
  authDomain: "hatmecem.firebaseapp.com",
  projectId: "hatmecem",
  storageBucket: "hatmecem.appspot.com",
  messagingSenderId: "488091987705",
  appId: "1:488091987705:web:7e379eb6bb50a0329a3c28",
  measurementId: "G-KP9CYHGH2Z",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
